@if (credits !== undefined) {
  <span class="credits ms-1">
    @if (app.view !== 'home' && !isCreated && !isEdited) {
      <ul
        class="creditsList"
        [ngClass]="app.thread.changeHeadlineColor()"
        >
        <li>
          {{ app.text.credits.created }} {{ app.text.credits.by }}
          <app-user-link
            class="text-credits-user"
            [name]="credits.user_id"
            [id]="credits.create_user_id"
            [type]="type"
          ></app-user-link>
          @if (credits.create_time != null && credits.create_time !== '') {
            <span>
              {{ app.text.credits.on }} {{ credits.create_time }}</span
              >
            }
          </li>
          @if (credits.update_user != null && credits.update_user !== '') {
            <li>
              @if (
                credits.user_id !== credits.update_user ||
                credits.create_time !== credits.update_time
                ) {
                <span
                  >
                  {{ app.text.credits.updated }}
                  @if (credits.user_id !== credits.update_user) {
                    <span>
                      {{ app.text.credits.by }}
                      <app-user-link
                        class="text-credits-user"
                        [name]="credits.update_user"
                        [id]="credits.update_user_id"
                      ></app-user-link>
                    </span>
                  }
                  @if (credits.create_time !== credits.update_time) {
                    <span>
                      {{ app.text.credits.on }} {{ credits.update_time }}
                    </span>
                  }
                </span>
              }
            </li>
          }
        </ul>
      }
      @if (isEdited && credits.create_time !== credits.update_time && credits.update_user_id != null) {
        <span>
          {{ app.text.credits.updated }}
          <span>
            {{ app.text.credits.by }}
            <app-user-link
              class="text-credits-user"
              [name]="credits.update_user"
              [id]="credits.update_user_id"
            ></app-user-link>
          </span>
          <span> {{ app.text.credits.on }} {{ credits.update_time }} </span>
        </span>
      }
      @if (isCreated && (credits.create_user_id != null || credits.user_id != null)) {
        <span>
          {{ app.text.credits.created }} {{ app.text.credits.by }}
          <app-user-link
            class="text-credits-user"
            [name]="credits.user_id"
            [id]="credits.create_user_id || credits.user_id"
            [type]="type"
          ></app-user-link>
          @if (credits.create_time != null && credits.create_time !== '') {
            <span>
              {{ app.text.credits.on }} {{ credits.create_time }}
            </span>
          }
        </span>
      }
    </span>
  }
